import { useCallback } from 'react';

export const useGetSplitId = () => useCallback((id: string) => id.split('_')[1] ?? id, []);
